import React from 'react';
import { Loader2 } from 'lucide-react';

const LoadingSpinner: React.FC = () => {
    return (
        <div className="flex items-center justify-center min-h-[60vh]">
            <div className="flex flex-col items-center">
                <Loader2 className="w-12 h-12 text-william-600 animate-spin mb-4" />
                <p className="text-gray-500 dark:text-gray-400 font-medium animate-pulse">
                    Loading BasiQR...
                </p>
            </div>
        </div>
    );
};

export default LoadingSpinner;
